const MAPS_KEY = "importedMaps";
const MAP_TYPE = "ImportMapItem"
export function setMaps(state, maps) {
  state.list = maps;
}

export function importMap(state, map) {
  const exist = state.list.find((m) => m.name === map.name);
  if (!exist) {
    state.list.push(map);
  }
}

//发布图层到球
export function addToEarth(state, map) {
  const exist = state.list.find((m) => m.name === map.name);
  if (exist) {
    map.added_to_map = true;
    const cloneMap = JSON.parse(JSON.stringify(map))
    cloneMap.mapType = MAP_TYPE
    cloneMap.addedTime = Date.now()
    state.addedList.push(cloneMap)
  }
}

//自球上删除图层
export function removeFromEarth(state, map) {
  const m = state.list.find((m) => m.name === map.name);
  const idx = state.addedList.findIndex((m) => m.name === map.name);
  if (idx >=0) {
    state.addedList.splice(idx,1)
    m.added_to_map = false;
  }
}

//删除图层
export function deleteMap(state, map) {
  const index = state.list.findIndex((m) => m.name === map.name);
  if (index >= 0) {
    state.list.splice(index, 1);
    window.localStorage.setItem(MAPS_KEY, JSON.stringify(state.list));
  }
}
